import * as React from "react"
import { useUnblockOrganizationMutation } from "@modules/organization/mutations.generated"
import { navigate } from "@gatsbyjs/reach-router"
import { OrganizationBaseDetailsDocument } from "@modules/organization/queries.generated"

export function useUnblockOrganization(id: string) {
  const [mutation, { loading }] = useUnblockOrganizationMutation()
  const [error, setError] = React.useState<string | null | undefined>()

  if (!id) {
    return {}
  }

  const unblock = () => {
    setError(``)

    mutation({
      variables: {
        organizationId: id,
      },
      refetchQueries: [
        {
          query: OrganizationBaseDetailsDocument,
          variables: { id },
        },
      ],
      awaitRefetchQueries: true,
    })
      .then(data => {
        if (data.data?.unblockOrganization?.success) {
          navigate(`/dashboard/sites`)
        } else {
          setError(data.data?.unblockOrganization?.message)
        }
      })
      .catch(err => {
        setError(err.message)
      })
  }

  return {
    unblock,
    unblocking: loading,
    unblockingError: error,
  }
}
